<template>
  <div class="km__modules__text--default">
    <ul class="km__list--modules">
      <li class="km__list__element--modules">
        <span
            v-if="show_textlist_button"
            @click="$emit('openTextList')"
            class="km__button--icon textlist">
          {{ $t("km_textliste_label") }}
        </span>
      </li>
      <!-- anlegen von leeren Text mit default-Werten -->
      <li class="km__list__element--modules">
        <button @click="$emit('createTextObject')" class="km__button--standard newtext" type="button" name="newtext">
          {{ $t("konf_newText") }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>

import {AnimationWaitingForTargetFactory, KeyFrameTargetValues} from "@km/animations/animationFactory";
import {setWatchToAnimateOnStatechange} from "@km/js/animater";
import {useModuleTextOpenStatusStore} from "@km/store/frontendstate/useModuleTextOpenState";

const props = defineProps({
  show_textlist_button: Boolean
})


const openStatusStore = useModuleTextOpenStatusStore();
setWatchToAnimateOnStatechange(

    AnimationWaitingForTargetFactory.getUpDownAnimation(".km__modules__text--default"),
    new KeyFrameTargetValues(0, 100),
    () => openStatusStore.getTextverwaltungState
);

</script>

<style lang="scss" scoped>
@use "../../scss/settings/config" as config;

/* ***********************************
*	LAYER 0: TEXT DEFAULT
*  - Buttons
*  - Buttons wrapper
*  - Layer wrapper
* ********************************** */

/* ***********************************
*	TEXT DEFAULT - Buttons
* ********************************** */
.km__button {
  &--icon {
    &.textlist {
      background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjQsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojMzMzMzMzO30NCjwvc3R5bGU+DQo8Zz4NCgk8cmVjdCB4PSIzMy44IiB5PSIyOS4yIiBjbGFzcz0ic3QwIiB3aWR0aD0iNDkuNyIgaGVpZ2h0PSI2Ii8+DQo8L2c+DQo8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIyMSIgY3k9IjMyLjIiIHI9IjQuNSIvPg0KPGc+DQoJPHJlY3QgeD0iMzMuOCIgeT0iNDYuNyIgY2xhc3M9InN0MCIgd2lkdGg9IjQ5LjciIGhlaWdodD0iNi42Ii8+DQo8L2c+DQo8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIyMSIgY3k9IjUwIiByPSI0LjUiLz4NCjxnPg0KCTxyZWN0IHg9IjMzLjgiIHk9IjY0LjUiIGNsYXNzPSJzdDAiIHdpZHRoPSI0OS43IiBoZWlnaHQ9IjYuNiIvPg0KPC9nPg0KPGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iMjEiIGN5PSI2Ny44IiByPSI0LjUiLz4NCjwvc3ZnPg0K');
      background-size: 32px;
      margin-top: 10px;
    }
  }

  &--standard {
    &.newtext {
      margin-top: 20px;
      height: 30px;

    }
  }
}

/* ***********************************
*	TEXT DEFAULT - Buttons wrapper
* ********************************** */
.km__modules__text--default {
  .km__list--modules {
    display: flex;
    flex-wrap: wrap;

    .km__list__element--modules {
      &:nth-child(1) {
        width: 28%;
      }

      &:nth-child(2) {
        width: 44%;
      }
    }
  }
}

/* ***********************************
*	TEXT DEFAULT - Layer wrapper
* ********************************** */
.km__modules__text--default {
  position: fixed;
  height: 100px;
  width: 100%;
  left: 0;
  bottom: config.$cta-height;
  z-index: 99;
  background: config.$color-white;
  padding: 15px 0 10px 0;
  transform: translate(0px, 100px);
  overflow-y: hidden;
}
</style>
